var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271 343",
    width: 271,
    height: 343,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e6e6e6 } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #6c63ff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0.6 319.5l0.8-296.4c0-3 0.6-5.9 1.8-8.7 1.1-2.7 2.8-5.2 4.9-7.3 2.1-2.1 4.6-3.8 7.3-4.9 2.8-1.1 5.7-1.7 8.7-1.7l223.8 0.6c3 0 5.9 0.6 8.7 1.8 2.7 1.1 5.2 2.8 7.3 4.9 2.1 2.1 3.8 4.6 4.9 7.4 1.1 2.7 1.7 5.6 1.7 8.6l-0.8 296.4c0 3-0.6 5.9-1.8 8.7-1.1 2.7-2.8 5.2-4.9 7.3-2.1 2.1-4.6 3.7-7.4 4.9-2.7 1.1-5.6 1.7-8.6 1.7l-223.9-0.7c-2.9 0-5.9-0.6-8.6-1.7-2.7-1.2-5.2-2.8-7.3-4.9-2.1-2.1-3.8-4.6-4.9-7.4-1.1-2.7-1.7-5.7-1.7-8.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m18 230l0.5-190.6c0-2.7 0.6-5.5 1.7-8.1 1-2.5 2.6-4.9 4.6-6.8 2-2 4.3-3.5 6.9-4.6 2.5-1.1 5.3-1.6 8.1-1.6l192.3 0.5c2.8 0 5.6 0.6 8.1 1.7 2.6 1.1 4.9 2.6 6.9 4.6 2 2 3.5 4.3 4.6 6.9 1 2.5 1.6 5.3 1.6 8.1l-0.8 263.7c0 2.8-0.5 5.6-1.6 8.1-1.1 2.6-2.6 4.9-4.6 6.9-2 2-4.3 3.5-6.9 4.6-2.6 1-5.3 1.6-8.1 1.6l-119.2-0.4c-12.4 0-24.6-2.5-36.1-7.3-11.4-4.8-21.8-11.7-30.5-20.5-8.7-8.8-15.7-19.2-20.4-30.7-4.7-11.5-7.1-23.7-7.1-36.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m210.1 102h-150c-2.4 0-4.7-0.9-6.4-2.6-1.6-1.7-2.6-4-2.6-6.4 0-2.4 1-4.7 2.6-6.4 1.7-1.6 4-2.6 6.4-2.6h150c2.4 0 4.7 1 6.4 2.6 1.7 1.7 2.6 4 2.6 6.4 0 2.4-0.9 4.7-2.6 6.4-1.7 1.7-4 2.6-6.4 2.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m93.1 60.5h-33c-2.4 0-4.7-0.9-6.4-2.6-1.6-1.7-2.6-4-2.6-6.4 0-2.4 1-4.7 2.6-6.4 1.7-1.6 4-2.6 6.4-2.6h33c2.4 0 4.7 1 6.4 2.6 1.7 1.7 2.6 4 2.6 6.4 0 2.4-0.9 4.7-2.6 6.4-1.7 1.7-4 2.6-6.4 2.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m210.1 143.5h-150c-2.4 0-4.7-0.9-6.4-2.6-1.6-1.7-2.6-4-2.6-6.4 0-2.4 1-4.7 2.6-6.4 1.7-1.6 4-2.6 6.4-2.6h150c2.4 0 4.7 1 6.4 2.6 1.7 1.7 2.6 4 2.6 6.4 0 2.4-0.9 4.7-2.6 6.4-1.7 1.7-4 2.6-6.4 2.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m210.1 185h-150c-2.4 0-4.7-0.9-6.4-2.6-1.6-1.7-2.6-4-2.6-6.4 0-2.4 1-4.7 2.6-6.4 1.7-1.6 4-2.6 6.4-2.6h150c2.4 0 4.7 1 6.4 2.6 1.7 1.7 2.6 4 2.6 6.4 0 2.4-0.9 4.7-2.6 6.4-1.7 1.7-4 2.6-6.4 2.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m198 294.4c-19.8 0-35.8-16.1-35.8-35.9 0-19.8 16-35.8 35.8-35.8 19.8 0 35.8 16 35.8 35.8 0 19.8-16 35.9-35.8 35.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m193.1 277.2q-0.5 0-0.9-0.1-0.5-0.1-0.9-0.3-0.4-0.2-0.8-0.5-0.3-0.3-0.6-0.7l-9.8-13c-0.6-0.9-0.9-1.9-0.7-3 0.1-1 0.7-2 1.5-2.6 0.9-0.7 1.9-0.9 3-0.8 1 0.2 2 0.7 2.6 1.6l6.4 8.5 16.4-24.6c0.6-0.9 1.5-1.5 2.5-1.7 1.1-0.2 2.2 0 3 0.6 0.9 0.5 1.5 1.5 1.7 2.5 0.2 1 0 2.1-0.6 3l-19.5 29.3q-0.3 0.4-0.6 0.7-0.4 0.4-0.8 0.6-0.4 0.2-0.9 0.3-0.4 0.2-0.9 0.2-0.1 0-0.1 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertify);
export default __webpack_public_path__ + "static/media/certify.7cf6000db8ab1e791657fe941a04b1e7.svg";
export { ForwardRef as ReactComponent };